import { createSlice } from '@reduxjs/toolkit'

const initialState = {
  isLoading: false,
  data: {
    initialized: false,
    authTokenSession: null,
    modulesStatuses: null,
    modulesStatusesEnergy: null,
    modulesStatusesInsurance: null,
    loaderRoutes: {
      home: '',
    },
    loaderRoutesEnergy: {
      home: '',
    },
    loaderRoutesInsurance: {
      home: '',
    },
    isSelectraAdmin: false,
    isAdmin: false,
    isMcpAgent: false,
    userId: null,
    sessionExpiration: null,
    authorizedSites: {},
    name: '',
    firstname: '',
    // Offers currently in cut period for the logged-in agent's team. Filled
    // from the login response (`cut_offers`) and kept in sync via the Echo
    // broadcast `team.offers-in-cut-period.{teamId}`. `teamName` is used by
    // the top banner to address the agent's team explicitly.
    // `cutOffersUpdatedAt` is bumped on every broadcast so the UI can flash
    // a "just updated" signal even when the list content is identical.
    teamId: null,
    teamName: '',
    teamCanCreateLeadsOnOwnVertical: false,
    hopTimusEnabled: false,
    betaFeatures: [],
    cutOffers: [],
    cutOffersUpdatedAt: 0,
    callbackRemindersEnabled: false,
    callbackCallEnabled: false,
  },
  error: '',
}

const updateAuthIsLoadingHandler = (state, action) => {
  state.isLoading = action.payload
}

const updateAuthDataHandler = (state, action) => {
  state.data = action.payload
}

const updateAuthErrorHandler = (state, action) => {
  state.error = action.payload
}

// Replace the cut-offers list with the freshest version pushed by the
// `team.offers-in-cut-period.{teamId}` broadcast. Always overwrites — the
// backend sends the whole list, not deltas.
// Also bump `cutOffersUpdatedAt` to a fresh timestamp so the banner can
// detect EVERY broadcast (including no-op refreshes where the list content
// happens to be identical) and trigger its "just updated" visual signal.
const updateCutOffersHandler = (state, action) => {
  state.data.cutOffers = Array.isArray(action.payload) ? action.payload : []
  state.data.cutOffersUpdatedAt = Date.now()
}

const updateCallbackRemindersEnabledHandler = (state, action) => {
  state.data.callbackRemindersEnabled = action.payload === true
}

export const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    updateAuthIsLoading: updateAuthIsLoadingHandler,
    updateAuthData: updateAuthDataHandler,
    updateAuthError: updateAuthErrorHandler,
    updateCutOffers: updateCutOffersHandler,
    updateCallbackRemindersEnabled: updateCallbackRemindersEnabledHandler,
    clearAuth: () => initialState,
  },
})

export const {
  updateAuthIsLoading,
  updateAuthData,
  updateAuthError,
  updateCutOffers,
  updateCallbackRemindersEnabled,
  clearAuth,
} = authSlice.actions

export default authSlice.reducer
